export default "__VITE_ASSET__BgBXkTBp__"